import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M3.6 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M7.058 10.625S8.1 12.708 10.6 12.708s3.541-2.083 3.541-2.083" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M9.35 8.333a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Zm3.333 0a.417.417 0 1 1-.833 0 .417.417 0 0 1 .833 0Z" fill="currentColor" stroke="currentColor" />' }
  })
);